import axios from 'axios';
import { upgradeEvents } from '../context/AuthContext';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Do not force redirect for login routes, so the component can show the "Invalid credentials" error
      if (error.config && !error.config.url.includes('/login')) {
        if (error.response?.data?.message === 'You have been logged out because your account was accessed from another device.') {
          alert(error.response.data.message);
        }
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    // Handle plan upgrade required
    if (error.response?.status === 403 && error.response?.data?.upgradePlan) {
      upgradeEvents.emit({
        feature: error.response.data.feature,
        requiredPlan: error.response.data.requiredPlan,
        message: error.response.data.message
      });
    }
    return Promise.reject(error);
  }
);

export default api;
